import { render } from "./Big2ResultsPage.vue?vue&type=template&id=23efd2f6&scoped=true"
import script from "./Big2ResultsPage.vue?vue&type=script&lang=js"
export * from "./Big2ResultsPage.vue?vue&type=script&lang=js"

import "./Big2ResultsPage.vue?vue&type=style&index=0&id=23efd2f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23efd2f6"]])

export default __exports__